import React from "react";

import SingleCourse from "./course_tabs/singleCourse";
import {BrowserRouter, Routes, Route } from "react-router-dom";
import Wrapper from "./Wrapper";

import "./style.css";

const App = () => {
  
  return (
    <>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Wrapper />}></Route>
          <Route path="courses/:id" element={<SingleCourse />}></Route>
        </Routes>
      </BrowserRouter>
    </>
  );
};

export default App;
